import api from './api';

export const getallUnapproved = async () => {
  const response = await api.get('/user_approval/');
  return response.data;
};

export const approveUser = async (userId) => {
  const response = await api.patch(`/user_approval/approve/${userId}`);
  return response.data;
};

export const rejectUser = async (userId) => {
  const response = await api.patch(`/user_approval/reject/${userId}`);
  return response.data;
};